import { message } from 'antd';

export const messageError = () => {
  message.error('訊息傳送失敗，不好意思QQ!');
};
export const messageSuccess = () => {
  message.success('收到訊息咯，非常感謝您！');
};
export const noMessageError = () => {
  message.error('寫點東西再傳吧，您怎麼看？');
};
export const loadingError = () => {
  message.error('傳遞訊息中，麻煩稍等哦～');
};
export const noSenderError = () => {
  message.error('讓我知道你/妳的名字嘛～');
};




// WEBPACK FOOTER //
// ./src/Components/Messenger/error.js